module.exports = __webpack_public_path__ + "static/media/Pheasant-Hills-Northville-Easements-Covenants-and-Restrictions.8c00f2d1.pdf";